import React, { useEffect, useState } from "react";
import { useStores } from "../hooks";
import { IEngagementsCustomer } from "../libs/models/Customer/EngagementsCustomer";

export interface IProps {
  location: Location;
}

export function authorize<Props extends IProps>(Component: (props: Props) => JSX.Element) {
  const AuthorizedComponent = (props: Props) => {
    const { customerStore, uiStore, rootStore, securePersistentStore, globalPersistentStore } = useStores();
    const [me, setMe] = useState<IEngagementsCustomer | null>();
    const [loginLoading, setLoginLoading] = useState(false);

    useEffect(() => {
      const fetchCustomer = async () => {
        if (securePersistentStore.accessToken) {
          setLoginLoading(true);

          const customer = customerStore.currentCustomer || (await customerStore.getCustomer());
          if (customer) {
            const engagementsTask = customerStore.getEngagements();

            const isZendeskEnabled = !!rootStore.getZendeskIdFromConfig();
            const zendeskTokenTask = isZendeskEnabled && !globalPersistentStore.zendeskToken ? customerStore.getZendeskToken() : undefined;
            await Promise.all([engagementsTask, zendeskTokenTask]);
            setLoginLoading(false);
            setMe(customer);
          } else {
            rootStore.logout(true);
          }
        } else {
          rootStore.logout(true);
        }
      };

      if (customerStore.currentCustomer && rootStore.allEngagements !== undefined) {
        setMe(customerStore.currentCustomer);
        return;
      }
      uiStore.setLoading(true);
      fetchCustomer();
    }, []);

    if (loginLoading || typeof me === "undefined") {
      return null;
    }

    return <Component {...props} />;
  };

  return AuthorizedComponent;
}
